import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';

import { useItemDisplayDimensions } from '../helpers/useItemDisplayDimensions';

import { ViewInRoomImageCredits_user$key } from './__generated__/ViewInRoomImageCredits_user.graphql';
import { ViewInRoomImageCredits_viewInRoomPhoto$key } from './__generated__/ViewInRoomImageCredits_viewInRoomPhoto.graphql';
import { ViewInRoomImageCredits_item$key } from './__generated__/ViewInRoomImageCredits_item.graphql';

import styles from './ViewInRoomImageCredits.scss';

const userFragment = graphql`
    fragment ViewInRoomImageCredits_user on User {
        ...useItemDisplayDimensions_user
    }
`;

const viewInRoomPhotoFragment = graphql`
    fragment ViewInRoomImageCredits_viewInRoomPhoto on viewInRoomPhotos {
        credits
    }
`;

const itemFragment = graphql`
    fragment ViewInRoomImageCredits_item on Item {
        ...useItemDisplayDimensions_item
    }
`;

export const ViewInRoomImageCredits: FC<{
    user: ViewInRoomImageCredits_user$key;
    viewInRoomPhoto: ViewInRoomImageCredits_viewInRoomPhoto$key;
    item: ViewInRoomImageCredits_item$key;
}> = ({ user: userRef, viewInRoomPhoto: viewInRoomPhotoRef, item: itemRef }) => {
    const user = useFragment(userFragment, userRef);
    const item = useFragment(itemFragment, itemRef);
    const viewInRoomPhoto = useFragment(viewInRoomPhotoFragment, viewInRoomPhotoRef);

    const { displayWidth, displayHeight } = useItemDisplayDimensions({ user, item });

    return (
        <div className={styles.wrapper}>
            <FormattedMessage
                id="ViewInRoomImageCredits.viewInRoomCredits"
                defaultMessage="{credits}. <span>Dimensions: H {height} x W {width}</span>"
                values={{
                    credits: viewInRoomPhoto.credits,
                    width: displayWidth,
                    height: displayHeight,
                    span: chunks => <span className={styles.dimensions}>{chunks}</span>,
                }}
            />
        </div>
    );
};
